/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import fetchHelper from "../../services/fetchHelper";

const typeValidation = {
  restoreDefault: "restoreDefaultCPTCodes",
  proceed: "dontCheckCPTCodes",
};

export default function ModalPhysicianAssignmentValidation({
  fetchIR,
  userId,
  readPhysicianId,
  reloadComponent,
}) {
  const handleSubmit = async (type) => {
    const param = `${type}=true`;
    const url = `/patientmanagement/rest/v2/interrogations/${userId}/assignEsigner/${readPhysicianId}?${param}`;
    await fetchHelper.putV2(url, {});
    if (type == typeValidation.restoreDefault) {
      reloadComponent();
    }
    fetchIR();
  };

  return (
    <div className="modal modal-physician-assignment override-row popup show">
      <div className="modalContent confirm">
        <h2>CPT Code validation failed</h2>
        <p>The selected codes do not match with default recommended codes</p>
        <div className="content-buttons-Sign_Next">
          <button
            type="button"
            id="btn-physician-assignment-review"
            className="btn btn-sm btn-hide-section"
            onClick={() => handleSubmit(typeValidation.restoreDefault)}
          >
            Restore default codes
          </button>
          <button
            type="button"
            id="btn-physician-assignment-confirm"
            className="btn btn-sm btnSuccess"
            onClick={() => handleSubmit(typeValidation.proceed)}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
}
